export enum ScheduleStatus {
  Wait = "WAIT",
  Work = "WORK",
  Completed = "COMPLETED",
}
